import React, { Component } from 'react';
import { View, Text} from 'react-native';
import Icon from '../../../Icon';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';
import { DEVICE_WIDTH } from '../../../../Constant/size';

const ZHUAN_TITLE_MAX_WIDTH = (DEVICE_WIDTH - 12 * 2 - 16 * 2 - 85 - 50) / 2;

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning',
    500050: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

const titleMap: { [propName: string]: string } = {
    5004002: '火车票-国际',
    5004003: '火车票-国际'
};

interface Props {
    data: {
        isEuropeanNormal: boolean;
        trainList: [];
        isHomeTrain: boolean;
        isTaiwanTrain: boolean;
        useBeginDate: string;
        useEndDate: string;
        internationalTitle: string;
        isEuropeanCity: boolean;
        productTitle: string;
        productDesc: string;
        _disable: boolean;
    };
}

class Train extends Component<Props> {
    public static formatData(data: any) {
        const newData = { ...data };

        // title
        newData.title = titleMap[newData.orderType] || '火车票';
        // icon
        newData.iconfont = '\uf1ee';
        newData.iconColor = '#47a0e5';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);

        if (newData.trainList) {
            newData.trainList = newData.trainList.map((train: any) => ({
                ...train,
                fixFromDate: train.departure ? train.departure.substring(0, 16) : '',
                fixToDate: train.arrival ? train.arrival.substring(11, 16) : '',
                trainNoStr: buildTrainNoStr(train)
            }));
        }
        if (newData.sysCode === 5001 || newData.sysCode === 5005 ||newData.sysCode === 5007) {
            newData.isHomeTrain = true;
        } else if (newData.sysCode === 5004) {
            if (newData.orderType === 5004001) {
                newData.isTaiwanTrain = true;
            } else if (newData.orderType === 5004002) {
                newData.isEuropeanNormal = true;
            } else if (newData.orderType === 5004003) {
                newData.isEuropeanCity = true;
            }
        }

        return newData;
    }

    public render() {
        const {
            data: {
                sysCode,
                isEuropeanNormal,
                trainList,
                isHomeTrain,
                isTaiwanTrain,
                useBeginDate,
                useEndDate,
                internationalTitle,
                isEuropeanCity,
                productTitle,
                productDesc,
                _disable
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                {isEuropeanNormal ? (
                    <View>
                        <Text style={styles.newOrderTitle} numberOfLines={2}>
                            {productTitle}
                        </Text>

                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {productDesc}
                        </Text>
                    </View>
                ) : null}
                {Boolean(trainList) &&
                    trainList.map((trainItem: TrainItemMode, index: number) => (
                        <View
                            style={
                                index === trainList.length - 1
                                    ? null
                                    : styles.ticketItemWithSiblings
                            }
                            key={index}
                        >
                            {isHomeTrain ? (
                                <View>
                                    {trainItem.fromStation || trainItem.toStation ? (
                                        sysCode === 5001 && trainItem.isTransfer ? (
                                            <View style={styles.transferRow} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_STATION)}>
                                                {Boolean(trainItem.fromStation) && (
                                                    <Text
                                                        style={[
                                                            styles.newOrderTitle,
                                                            { maxWidth: ZHUAN_TITLE_MAX_WIDTH }
                                                        ]}
                                                        numberOfLines={1}
                                                    >
                                                        {`${trainItem.fromStation}${
                                                            trainItem.toStation ? '  ' : ''
                                                        }`}
                                                    </Text>
                                                )}
                                                {Boolean(
                                                    trainItem.fromStation && trainItem.toStation
                                                ) && (
                                                    <View style={styles.transferWrapper}>
                                                        <Icon
                                                            code="&#xe6d7;"
                                                            style={[
                                                                styles.transferIcon,
                                                                { top: 1 }
                                                            ]}
                                                            size={12}
                                                        />
                                                        <View style={styles.transferTextWrapper}>
                                                            <Text
                                                                style={[
                                                                    styles.transferText,
                                                                    {
                                                                        backgroundColor:
                                                                            'transparent'
                                                                    }
                                                                ]}
                                                            >
                                                                转
                                                            </Text>
                                                        </View>
                                                        <Icon
                                                            code="&#xe6d8;"
                                                            style={[
                                                                styles.transferIcon,
                                                                { marginLeft: 2, top: 1 }
                                                            ]}
                                                            size={12}
                                                        />
                                                    </View>
                                                )}
                                                {Boolean(trainItem.toStation) && (
                                                    <Text
                                                        style={[
                                                            styles.newOrderTitle,
                                                            { maxWidth: ZHUAN_TITLE_MAX_WIDTH }
                                                        ]}
                                                        numberOfLines={1}
                                                    >
                                                        {`${trainItem.fromStation ? '  ' : ''}${
                                                            trainItem.toStation
                                                        }`}
                                                    </Text>
                                                )}
                                            </View>
                                        ) : (
                                            <Text style={styles.newOrderTitle} numberOfLines={2} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_STATION)}>
                                                {Boolean(trainItem.fromStation) &&
                                                    `${trainItem.fromStation}${
                                                        trainItem.toStation ? '  ' : ''
                                                    }`}
                                                {Boolean(
                                                    trainItem.fromStation && trainItem.toStation
                                                ) && <Icon code="&#xe6c2;" size={14} />}
                                                {Boolean(trainItem.toStation) &&
                                                    `${trainItem.fromStation ? '  ' : ''}${
                                                        trainItem.toStation
                                                    }`}
                                            </Text>
                                        )
                                    ) : null}
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_DATE)}>
                                        {`${trainItem.fixFromDate}~${trainItem.fixToDate}`}
                                        {Boolean(trainItem.days) && (
                                            <Text style={styles.oneMoreDay}>
                                                {` ${trainItem.days > 0 ? '+' : ''}${
                                                    trainItem.days
                                                }天`}
                                            </Text>
                                        )}
                                    </Text>
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_TRAIN_NO)}>
                                        {trainItem.trainNoStr}&nbsp;&nbsp;{trainItem.seatNoDesc}
                                    </Text>
                                </View>
                            ) : null}
                            {isTaiwanTrain ? (
                                <View>
                                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                                        {internationalTitle}
                                    </Text>
                                    {trainItem.fromStation || trainItem.toStation ? (
                                        trainItem.isTransfer ? (
                                            <View style={styles.transferRow} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_STATION)}>
                                                {Boolean(trainItem.fromStation) && (
                                                    <Text
                                                        style={[
                                                            styles.newOrderSubTitle,
                                                            { maxWidth: ZHUAN_TITLE_MAX_WIDTH }
                                                        ]}
                                                        numberOfLines={1}
                                                    >
                                                        {`${trainItem.fromStation}${
                                                            trainItem.toStation ? '  ' : ''
                                                        }`}
                                                    </Text>
                                                )}
                                                {Boolean(
                                                    trainItem.fromStation && trainItem.toStation
                                                ) && (
                                                    <View
                                                        style={[
                                                            styles.transferWrapper,
                                                            { marginBottom: 0 }
                                                        ]}
                                                    >
                                                        <Icon
                                                            code="&#xe6d7;"
                                                            style={[
                                                                styles.transferIcon,
                                                                styles.transferIconSub,
                                                                { top: 1 }
                                                            ]}
                                                            size={12}
                                                        />
                                                        <View
                                                            style={[
                                                                styles.transferTextWrapper,
                                                                styles.transferTextWrapperSub
                                                            ]}
                                                        >
                                                            <Text
                                                                style={[
                                                                    styles.transferText,
                                                                    styles.transferTextSub,
                                                                    {
                                                                        backgroundColor:
                                                                            'transparent'
                                                                    }
                                                                ]}
                                                            >
                                                                转
                                                            </Text>
                                                        </View>
                                                        <Icon
                                                            code="&#xe6d8;"
                                                            style={[
                                                                styles.transferIcon,
                                                                styles.transferIconSub,
                                                                { marginLeft: 2, top: 1 }
                                                            ]}
                                                            size={12}
                                                        />
                                                    </View>
                                                )}
                                                {Boolean(trainItem.toStation) && (
                                                    <Text
                                                        style={[
                                                            styles.newOrderSubTitle,
                                                            { maxWidth: ZHUAN_TITLE_MAX_WIDTH }
                                                        ]}
                                                        numberOfLines={1}
                                                    >
                                                        {`${trainItem.fromStation ? '  ' : ''}${
                                                            trainItem.toStation
                                                        }`}
                                                    </Text>
                                                )}
                                            </View>
                                        ) : (
                                            <Text style={styles.newOrderSubTitle} numberOfLines={2} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_STATION)}>
                                                {Boolean(trainItem.fromStation) &&
                                                    `${trainItem.fromStation}${
                                                        trainItem.toStation ? '  ' : ''
                                                    }`}
                                                {Boolean(
                                                    trainItem.fromStation && trainItem.toStation
                                                ) && <Icon code="&#xe6c2;" size={14} />}
                                                {Boolean(trainItem.toStation) &&
                                                    `${trainItem.fromStation ? '  ' : ''}${
                                                        trainItem.toStation
                                                    }`}
                                            </Text>
                                        )
                                    ) : null}
                                    {Boolean(useBeginDate && useEndDate) && (
                                        <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_DATE)}>
                                            {`${useBeginDate} 至 ${useEndDate} 有效`}
                                        </Text>
                                    )}
                                </View>
                            ) : null}
                            {isEuropeanCity ? (
                                <View>
                                    {trainItem.fromStation || trainItem.toStation ? (
                                        trainItem.isTransfer ? (
                                            <View style={styles.transferRow} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_STATION)}>
                                                {Boolean(trainItem.fromStation) && (
                                                    <Text
                                                        style={[
                                                            styles.newOrderTitle,
                                                            { maxWidth: ZHUAN_TITLE_MAX_WIDTH }
                                                        ]}
                                                        numberOfLines={1}
                                                    >
                                                        {`${trainItem.fromStation}${
                                                            trainItem.toStation ? '  ' : ''
                                                        }`}
                                                    </Text>
                                                )}
                                                {Boolean(
                                                    trainItem.fromStation && trainItem.toStation
                                                ) && (
                                                    <View style={styles.transferWrapper}>
                                                        <Icon
                                                            code="&#xe6d7;"
                                                            style={[
                                                                styles.transferIcon,
                                                                { top: 1 }
                                                            ]}
                                                            size={12}
                                                        />
                                                        <View style={styles.transferTextWrapper}>
                                                            <Text
                                                                style={[
                                                                    styles.transferText,
                                                                    {
                                                                        backgroundColor:
                                                                            'transparent'
                                                                    }
                                                                ]}
                                                            >
                                                                转
                                                            </Text>
                                                        </View>
                                                        <Icon
                                                            code="&#xe6d8;"
                                                            style={[
                                                                styles.transferIcon,
                                                                { marginLeft: 2, top: 1 }
                                                            ]}
                                                            size={12}
                                                        />
                                                    </View>
                                                )}
                                                {Boolean(trainItem.toStation) && (
                                                    <Text
                                                        style={[
                                                            styles.newOrderTitle,
                                                            { maxWidth: ZHUAN_TITLE_MAX_WIDTH }
                                                        ]}
                                                        numberOfLines={1}
                                                    >
                                                        {`${trainItem.fromStation ? '  ' : ''}${
                                                            trainItem.toStation
                                                        }`}
                                                    </Text>
                                                )}
                                            </View>
                                        ) : (
                                            <Text style={styles.newOrderTitle} numberOfLines={2} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_STATION)}>
                                                {Boolean(trainItem.fromStation) &&
                                                    `${trainItem.fromStation}${
                                                        trainItem.toStation ? '  ' : ''
                                                    }`}
                                                {Boolean(
                                                    trainItem.fromStation && trainItem.toStation
                                                ) && <Icon code="&#xe6c2;" size={14} />}
                                                {Boolean(trainItem.toStation) &&
                                                    `${trainItem.fromStation ? '  ' : ''}${
                                                        trainItem.toStation
                                                    }`}
                                            </Text>
                                        )
                                    ) : null}
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_DEP_DATE)}>
                                        {`${trainItem.fixFromDate}~${trainItem.fixToDate}`}

                                        {Boolean(trainItem.days) && (
                                            <Text style={styles.oneMoreDay}>
                                                {` ${trainItem.days > 0 ? '+' : ''}${
                                                    trainItem.days
                                                }天`}
                                            </Text>
                                        )}
                                    </Text>
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TRAIN_TRAIN_NO)}>
                                        {trainItem.trainNoStr}&nbsp;&nbsp;{trainItem.seatNoDesc}
                                    </Text>
                                </View>
                            ) : null}
                        </View>
                    ))}
            </View>
        );
    }
}

function buildTrainNoStr(trainInfo: { trainNo: string[] }) {
    const result: string[] = [];
    trainInfo.trainNo &&
        trainInfo.trainNo.forEach((No) => {
            if (No) {
                result.push(`车次 ${No}`);
            }
        });
    return result.join('    ') || '';
}

export default Train;

interface TrainItemMode {
    fromStation: string;
    toStation: string;
    isTransfer: boolean;
    fixFromDate: string;
    fixToDate: string;
    days: number;
    trainNoStr: string;
    seatNoDesc: string;
}
